import React from 'react';
import styles from '../styles/Cart.module.css';

const formatPrice = value => `${value.toFixed(2).replace('.', ',')} €`;

const Cart = ({ items, onChangeQuantity, onRemove, onCheckout, isCheckingOut, checkoutError }) => {
  const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

  return (
    <aside className={styles.cart} aria-labelledby="cart-title">
      <div className={styles.heading}>
        <p className={styles.label}>Your order</p>
        <h2 id="cart-title">Shopping cart</h2>
      </div>

      {items.length === 0 ? (
        <p className={styles.empty}>Your cart is empty. Add some fresh bread to begin.</p>
      ) : (
        <>
          <div className={styles.items}>
            {items.map(item => (
              <div className={styles.item} key={item.id}>
                <img src={item.image} alt="" loading="lazy" decoding="async" />
                <div className={styles.itemCopy}>
                  <h3>{item.name}</h3>
                  <p>{formatPrice(item.price)}</p>
                  <div className={styles.controls}>
                    <button
                      type="button"
                      onClick={() => onChangeQuantity(item.id, item.quantity - 1)}
                      aria-label={`Decrease ${item.name} quantity`}
                    >
                      −
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      onClick={() => onChangeQuantity(item.id, item.quantity + 1)}
                      aria-label={`Increase ${item.name} quantity`}
                    >
                      +
                    </button>
                    <button
                      className={styles.remove}
                      type="button"
                      onClick={() => onRemove(item.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
                <strong className={styles.lineTotal}>{formatPrice(item.price * item.quantity)}</strong>
              </div>
            ))}
          </div>

          <div className={styles.total}>
            <span>Total</span>
            <strong>{formatPrice(total)}</strong>
          </div>
          {checkoutError && <p className={styles.error} role="alert">{checkoutError}</p>}
          <button className={styles.checkout} type="button" onClick={onCheckout} disabled={isCheckingOut}>
            {isCheckingOut ? 'Preparing order…' : 'Continue to order details'}
          </button>
        </>
      )}
    </aside>
  );
};

Cart.defaultProps = {
  items: [],
  onChangeQuantity: () => {},
  onRemove: () => {},
  onCheckout: () => {},
  isCheckingOut: false,
  checkoutError: '',
};

export default Cart;
